import { Pipe, PipeTransform } from '@angular/core';
import { ProcedureTransactionSummaryViewModel } from 'data';

@Pipe({
  standalone: false,
  name: 'procedureSummaryDescription'
})
export class ProcedureSummaryDescriptionPipe implements PipeTransform {
  transform(value: ProcedureTransactionSummaryViewModel): string {
    const displayValue = [];
    var modifiers = "";
    if (value?.modifier1Code) {
      modifiers += value?.modifier1Code;
      if (value?.modifier2Code) {
        modifiers += ':' + value?.modifier2Code;
        if (value?.modifier3Code) {
          modifiers += ':' + value?.modifier3Code;
          if (value?.modifier4Code) {
            modifiers += ':' + value?.modifier4Code;
          }
        }
      }
    }
    if (value?.procedureCode) {
      if (modifiers !== "") {
        displayValue.push(value?.procedureCode + "/" + modifiers);
      } else {
        displayValue.push(value?.procedureCode);
      }
    }
    
    if (value?.procedureDescription) {
      displayValue.push(value?.procedureDescription);
    }

    return displayValue.join(', ');
  }
}
